import React from 'react';

import { Title } from 'components/commons';

type DesistedLayoutProps = {}

const DesistedLayout: React.FC<DesistedLayoutProps> = ({}) => {
    return (
        <div className="message-box-container denied-container">
            <div className="inner">
                <div className="screen">
                    <div className="message-box">
                        <Title>
                            obg pela sua resposta 😉
                        </Title>

                        <p className="text">
                            Levaremos seu feedback em consideração para melhorar cada vez mais.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default DesistedLayout;
